export function productPreviewImageUrl(primaryImageUrl: unknown): string | undefined {
  if (typeof primaryImageUrl !== "string") return undefined;
  const baseUrl = primaryImageUrl.trim().replace(/\/+$/, "");
  if (!baseUrl) return undefined;
  return baseUrl.endsWith("/preview") ? baseUrl : `${baseUrl}/preview`;
}

export function productThumbnailImageUrl(primaryImageUrl: unknown): string | undefined {
  if (typeof primaryImageUrl !== "string") return undefined;
  const baseUrl = primaryImageUrl.trim().replace(/\/+$/, "").replace(/\/(preview|thumb|thumbnail)$/, "");
  if (!baseUrl) return undefined;
  return `${baseUrl}/thumbnail`;
}
